import { calculateNegotiatedVolumeBRL } from './calculateNegotiatedVolumeBRL.js'
import { calculateConvertedVolumeBRL } from './calculateConvertedVolumeBRL.js'

// Conversion rate (%) = converted volume (DEAL) / negotiated volume
// (DEAL + NOTH.DONE), both in BRL. effectiveSpotByRow must come from
// createEffectiveSpotMap(allRows).
export function calculateConversionRate(rows, effectiveSpotByRow) {
  if (!rows.length) return 0

  const negotiatedVol = calculateNegotiatedVolumeBRL(rows, effectiveSpotByRow)
  const convertedVol = calculateConvertedVolumeBRL(rows, effectiveSpotByRow)

  if (negotiatedVol === 0) return 0

  const percentage = (convertedVol / negotiatedVol) * 100

  return Math.trunc(percentage * 100) / 100
}
